import type { SwitchChangeEvent } from "@tql/ui-components-react/kendo/inputs";
import { Switch } from "@tql/ui-components-react/kendo/inputs";
import { Label } from "@tql/ui-components-react/kendo/labels";
import type { ComponentProps } from "react";

import { UserFilterMultiselect } from "~/features/quote-board/quote-board-header/user-filter-multiselect.tsx";
import type { ShipmentStats } from "~/shared/schemas/loads-schema.ts";
import type { BoardColumn } from "~/shared/types/quote-board-types";

import { LoadSummaryCards } from "../load-summary-cards/load-summary-cards.tsx";
import { LoadsHeader } from "../loads-header/loads-header.tsx";

type UserFilterMultiselectProps = ComponentProps<typeof UserFilterMultiselect>;

type InternalShipmentBoardHeaderProps = {
	allColumns: BoardColumn[];
	onChangeColumn: (column: BoardColumn) => void;
	onClearFilters: () => void;
	onRefresh: () => void;
	onResetColumns?: () => void;
	selectedUserFilter: UserFilterMultiselectProps["selectedFilter"];
	userFilterValue: UserFilterMultiselectProps["selectedValue"];
	onUserFilterChange: UserFilterMultiselectProps["onHandleChange"];
	onSelectUserFilter: UserFilterMultiselectProps["onHandleSelectFilter"];
	userFilters: UserFilterMultiselectProps["userFilters"];
	needsAcknowledgment: boolean;
	onAcknowledgmentFilterChange: (value: boolean) => void;
	activeCardType: string | null;
	isLoadingLoads: boolean;
	summary: ShipmentStats;
	onClickSummaryCard: (status: string, needsImmediateAction: boolean) => void;
};

export const InternalShipmentBoardHeader = ({
	allColumns,
	onChangeColumn,
	onClearFilters,
	onRefresh,
	onResetColumns,
	selectedUserFilter,
	userFilterValue,
	onUserFilterChange,
	onSelectUserFilter,
	userFilters,
	needsAcknowledgment,
	onAcknowledgmentFilterChange,
	activeCardType,
	isLoadingLoads,
	summary,
	onClickSummaryCard,
}: InternalShipmentBoardHeaderProps) => {
	return (
		<>
			<div className={"loads-header-row"}>
				<LoadsHeader
					columns={allColumns}
					onChangeColumn={onChangeColumn}
					onClearFilters={onClearFilters}
					onRefresh={onRefresh}
					onResetColumns={onResetColumns}
				/>
			</div>
			<div className={"loads-header-filters"}>
				<UserFilterMultiselect
					onHandleChange={onUserFilterChange}
					onHandleSelectFilter={onSelectUserFilter}
					selectedFilter={selectedUserFilter}
					selectedValue={userFilterValue}
					userFilters={userFilters}
				/>

				<div className={"push-right"}>
					<div className={"loads-header-filter-exceptions"}>
						<Label>Show Only Needs Acknowledgeable Exceptions:</Label>
					</div>
					<div>
						<Switch
							ariaLabel={"Show Only Needs Acknowledgeable Exceptions"}
							checked={needsAcknowledgment}
							onChange={(e: SwitchChangeEvent) => {
								onAcknowledgmentFilterChange(e.value);
							}}
						/>
					</div>
				</div>
			</div>

			<LoadSummaryCards
				activeCardType={activeCardType}
				isLoading={isLoadingLoads}
				onClickSummaryCard={onClickSummaryCard}
				summary={summary}
			/>
		</>
	);
};
